{
  "studio.appShell.title": "ElectroCraft Studio",
  "studio.appShell.sidebarLabel": "Navegación principal del Studio",
  "studio.appShell.navigationLabel": "Navegación del Studio",
  "studio.appShell.menuLabel": "Abrir navegación",
  "studio.appShell.menuTitle": "Navegación",
  "studio.appShell.menuDescription": "Navegación global agrupada del Studio. El estado activo y los iconos se mantienen accesibles también en modo compacto.",
  "studio.appShell.closeMenuLabel": "Cerrar navegación",
  "studio.appShell.collapseSidebarLabel": "Contraer barra lateral",
  "studio.appShell.expandSidebarLabel": "Expandir barra lateral",
  "studio.appShell.workspaceLabel": "Área de trabajo del Studio",
  "studio.appShell.emptyWorkspace": "Área de trabajo vacía",
  "studio.appShell.statusLabel": "Estado del Studio",
  "studio.appShell.status.ready": "Listo",
  "studio.appShell.status.saving": "Guardando",
  "studio.appShell.status.error": "Error",
  "studio.appShell.status.blocked": "Bloqueado",
  "studio.topbar.breadcrumbRoot": "Studio",
  "studio.topbar.projectsLabel": "Proyectos",
  "studio.topbar.projectLabel": "Proyecto local",
  "studio.topbar.save.ready": "Guardado",
  "studio.topbar.save.saving": "Guardando…",
  "studio.topbar.save.error": "Error de guardado",
  "studio.topbar.save.blocked": "Bloqueado",
  "studio.topbar.documentLabel": "Documento",
  "studio.topbar.documentFallback": "Inicio",
  "studio.topbar.platformLabel": "Plataforma",
  "studio.topbar.platformValue": "Web",
  "studio.topbar.breakpointLabel": "Breakpoint",
  "studio.topbar.breakpoint.mobile": "Móvil",
  "studio.topbar.breakpoint.tablet": "Tablet",
  "studio.topbar.breakpoint.laptop": "Portátil",
  "studio.topbar.breakpoint.desktop": "Escritorio",
  "studio.topbar.undoLabel": "Deshacer",
  "studio.topbar.redoLabel": "Rehacer",
  "studio.topbar.historyLabel": "Historial",
  "studio.topbar.historyUnavailable": "Historial de sesión no disponible en esta ruta",
  "studio.topbar.zoomLabel": "Zoom",
  "studio.topbar.toolsLabel": "Abrir herramientas contextuales",
  "studio.topbar.toolsTitle": "Herramientas contextuales",
  "studio.topbar.toolsDescription": "Documento, plataforma, breakpoint, historial persistente y zoom permanecen accesibles sin comprimir el área de trabajo.",
  "studio.topbar.previewLabel": "Vista previa",
  "studio.topbar.exportLabel": "Exportar",
  "studio.topbar.localLabel": "Local",
  "studio.topbar.helpLabel": "Ayuda",
  "studio.topbar.helpDescription": "Ayuda persistente del AppShell y sus preferencias de espacio de trabajo.",
  "studio.topbar.closeHelpLabel": "Cerrar ayuda",
  "studio.topbar.settingsLabel": "Configuración",
  "studio.topbar.settingsTitle": "Configuración",
  "studio.topbar.settingsDescription": "Preferencias del Studio separadas del modelo canónico del proyecto.",
  "studio.topbar.closeSettingsLabel": "Cerrar configuración",
  "studio.topbar.workspaceSettingsTitle": "Espacio de trabajo",
  "studio.topbar.sidebarPreferenceLabel": "Barra lateral",
  "studio.topbar.sidebarExpandedLabel": "Expandida",
  "studio.topbar.sidebarCollapsedLabel": "Contraída",
  "studio.topbar.collapseSidebarAction": "Contraer",
  "studio.topbar.expandSidebarAction": "Expandir",
  "items.count_one": "{{count}} elemento",
  "items.count_other": "{{count}} elementos",
  "action.save": "Guardar",
  "action.cancel": "Cancelar"
}
